import { Api } from "src/core/decorators/dto/api.decorator";
import { DtoHasApi } from "../shared/dto-has-api.model";

@Api('api/app/custom-fields')
export class CustomFieldDto extends DtoHasApi {
    id: number;
    fieldKey: string | null;
    pbxKey: string | null;
    isActive: string;
}